module.exports = __webpack_public_path__ + "static/media/fiets.51a7e063.png";